module.exports = __webpack_public_path__ + "static/media/question-button.58ee4ccc.png";